import { DataTable } from "@/components/data-table";
import { dilemmasColumns } from "@/features/dilemmas/components/dilemmas-columns";
import { useTranslation } from "react-i18next";
import EmptyTable from "@/components/empty-table";
import { useDilemmasList } from "@/features/dilemmas/hooks/useDilemmasList";
import SearchInput from "@/components/search-input";
import ListContent from "@/features/dilemmas/components/list-content";
import { useDilemmasFilterStore } from "@/features/dilemmas/stores";
import DilemmasFilterComponent from "@/features/dilemmas/components/filter-component";
import { ROUTES } from "@/constants/routes";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { selectedRowsAtom } from "@/stores/atoms/selected-rows-atom";
import { useEffect } from "react";
import AiWritingAssistantFab from "@/features/ai-writing-assistant/components/ai-writing-assistant-fab";

const DilemmasListPage = () => {
  const { t } = useTranslation();
  const [rowSelection, setRowSelection] = useAtom(selectedRowsAtom);
  const { dilemmas, page, pageCount, setPage, isLoading, isFetching } =
    useDilemmasList();
  const {
    searchValue,
    setSearchValue,
    setStatusFilter,
    setOrdering,
    setLanguageFilter,
    setThemeFilter,
  } = useDilemmasFilterStore();

  useEffect(() => {
    return () => {
      setSearchValue(null);
      setStatusFilter(null);
      setOrdering(null);
      setLanguageFilter(null);
      setThemeFilter(null);
    };
  }, [
    setSearchValue,
    setStatusFilter,
    setOrdering,
    setLanguageFilter,
    setThemeFilter,
  ]);

  return (
    <div className="flex flex-col gap-y-3 pt-3 sm:pt-6 pb-24 relative">
      <div className="flex items-center gap-2 lg:hidden px-3 sm:px-6">
        <SearchInput
          value={searchValue ?? ""}
          onChange={setSearchValue}
          placeholder={t("keys.search")}
        />
        <DilemmasFilterComponent />
      </div>
      <div className="hidden md:block overflow-x-scroll px-3 sm:px-6">
        <DataTable
          columns={dilemmasColumns(t)}
          data={dilemmas}
          page={page}
          pageCount={pageCount}
          onPageChange={setPage}
          isLoading={isLoading || isFetching}
          emptyListComponent={<EmptyTableComponent />}
          rowSelection={rowSelection}
          onRowSelectionChange={setRowSelection}
        />
      </div>
      <ListContent
        data={dilemmas}
        isLoading={isLoading || isFetching}
        page={page}
        pageCount={pageCount}
        onPageChange={setPage}
        className="md:hidden"
        emptyListComponent={<EmptyTableComponent />}
        rowSelection={rowSelection}
        onRowSelectionChange={setRowSelection}
      />
      <AiWritingAssistantFab />
    </div>
  );
};

const EmptyTableComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <EmptyTable
      title={t("modules.dilemmas.datatable.no_dilemmas")}
      subtitle={t("modules.dilemmas.datatable.add_dilemma")}
      action={() => navigate(ROUTES.DILEMMA_CREATE)}
      actionTitle={t("modules.dilemmas.keys.add_dilemma")}
    />
  );
};

export default DilemmasListPage;
